export default [
  {
    id: 'ef37edda-cabd-4435-9511-30aa29734545', // id 全局唯一，终身制
    name: 'visualizationCockpitTongre',
    path: '/visualization-cockpit-tongre',
    meta: { title: '三维可视化' },
    layout: 'fullscreen',
    // 根菜单不需要定义 component，由主框架定义
    children: [
      {
        id: '2b11ad14-17fe-471e-9d96-04832511010b',
        path: 'index',
        name: 'visualizationCockpitIndex',
        component: () => {
          return import('./views/index')
        },
        meta: {
          title: '三维可视化',
        },
      },
    ],
  },
]
